export default __webpack_public_path__ + "static/media/notes2.c1f32648.svg";